import { render, staticRenderFns } from "./LeftBottom.vue?vue&type=template&id=23177020"
import script from "./LeftBottom.vue?vue&type=script&lang=js"
export * from "./LeftBottom.vue?vue&type=script&lang=js"
import style0 from "./LeftBottom.vue?vue&type=style&index=0&id=23177020&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports